import React, { useContext, Fragment } from "react";
import { EligibilityContext } from "../../contexts/EligibilityContext";

const CriteriaRadio = ({ criteria, register, errors }) => {
  const context = useContext(EligibilityContext);
  const options = criteria.options.split(";");

  return (
    <fieldset className="u-mb4">
      <legend>
        {criteria.criteria}

        {errors[criteria.name] && errors[criteria.name].type === "required" && (
          <span data-validate="error">Please make a selection.</span>
        )}
      </legend>
      {options.map((option, index) => (
        <Fragment key={index}>
          <input
            id={`${criteria.name}-${index}`}
            type="radio"
            name={criteria.name}
            value={JSON.stringify({
              criteria: criteria.criteria,
              fundId: context.state.diseaseFund.fundId,
              answerType: criteria.answerType,
              response: option,
              id: criteria.id,
              criteriaMetaDataName: criteria.criteriaMetaDataName,
            })}
            ref={register({
              required: true,
            })}
          />
          <label htmlFor={`${criteria.name}-${index}`}>{option}</label>
        </Fragment>
      ))}
    </fieldset>
  );
};

export default CriteriaRadio;
